import {
  validateEvidenceLabConfig,
  type EvidenceLabConfig,
} from '../minigames/evidence-lab/EvidenceLabConfig.js';

export const EARTH_MATERIALS_INVESTIGATION: EvidenceLabConfig = {
  id: 'earth-material-properties-1',
  skillId: 'science-earth-materials-1',
  question: 'Which explanation is supported by all four Earth-material observations?',
  subjects: [
    {
      id: 'sand',
      label: 'SAND',
      observation: 'Sand is made of many small, loose grains that pour into a pile.',
      evidenceId: 'sand-loose-grains',
    },
    {
      id: 'soil',
      label: 'SOIL',
      observation: 'Soil is dark and crumbly, with bits of once-living material mixed in.',
      evidenceId: 'soil-dark-crumbly',
    },
    {
      id: 'rock',
      label: 'ROUNDED ROCK',
      observation: 'The rock is hard, solid, and keeps its shape when moved.',
      evidenceId: 'rock-hard-solid',
    },
    {
      id: 'water',
      label: 'WATER',
      observation: 'Water flows and takes the shape of its shallow container.',
      evidenceId: 'water-flows',
    },
  ],
  conclusions: [
    {
      id: 'different-properties',
      text: 'Earth materials have different observable properties: some are loose or hard solids, while water flows.',
    },
    { id: 'all-identical', text: 'Sand, soil, rock, and water all have exactly the same properties.' },
    { id: 'all-liquids', text: 'Every Earth material is a liquid that takes its container’s shape.' },
  ],
  correctConclusionId: 'different-properties',
  requiredEvidenceIds: [
    'sand-loose-grains',
    'soil-dark-crumbly',
    'rock-hard-solid',
    'water-flows',
  ],
  hints: [
    'Record texture, shape, and movement for every sample.',
    'Compare the loose grains with the solid rock and the flowing water.',
    'The observations describe different properties, not one property shared by every sample.',
  ],
  evidenceExplanation:
    'Sand has loose grains, soil is crumbly, rock is hard and keeps its shape, and water flows to fit its container.',
  successMessage: 'The geology beacon shines and every Earth-material bay sparkles!',
  restorationEvent: 'earth-materials-yard-restored',
};

validateEvidenceLabConfig(EARTH_MATERIALS_INVESTIGATION);
